<template>
  <div v-click-outside="hide">
    <div class="points" @click="show">
    <span v-for="point in testPoints" :key="point.name" class="points__item" :title="point.name">
                  {{getPoint(answer, point)}}
                </span>
    </div>
    <transition name="fade">
      <div class="info" v-show="display">
        <i class="close" @click="hide">
          <font-awesome-icon icon="times"/>
        </i>
        <table>
          <tr v-for="point in testPoints" :key="point.name">
            <td>{{point.name}}:</td>
            <td>
              <SmartInput :value="getPoint(answer, point)"
                          @change="changeAnswerPoint($event, point.name, answer)"/>
            </td>
          </tr>
        </table>
      </div>
    </transition>
  </div>
</template>

<script>
  import SmartInput from '@/components/SmartInput'
  import ClickOutside from 'vue-click-outside'

  export default {
    name: 'AnswerPoints',
    props: ['answer'],
    directives: {
      ClickOutside
    },
    data () {
      return {
        display: false
      }
    },
    components: {
      SmartInput
    },
    computed: {
      testPoints () {
        return this.$store.getters.test.points
      }
    },
    methods: {
      getPoint (answer, point) {
        if (answer.points == null) {
          answer.points = []
          return 0
        }
        const pointIndex = answer.points.findIndex(
          x => x.name === point.name)
        if (pointIndex === -1) {
          return 0
        }
        return answer.points[pointIndex].value
      },
      changeAnswerPoint (event, name, answer) {
        const pointIndex = answer.points.findIndex(
          x => x.name === name)
        if (pointIndex === -1) {
          answer.points.push({name, value: event})
        } else {
          answer.points[pointIndex].value = event
        }
        this.$emit('answerChange', answer)
      },
      show () {
        this.display = true
      },
      hide () {
        this.display = false
      }
    }
  }
</script>

<style scoped lang="scss">
  .points {
    cursor: pointer;
    &:hover {
      border-bottom: 1px solid $blue;
    }
    &__item {
      padding-right: 5px;
      &:last-child {
        padding-right: 0;
      }
    }
  }

  .info {
    position: absolute;
    top: 15px;
    right: -30px;
    background-color: #fff;
    padding: 40px 20px 20px 20px;
    z-index: 100;
    min-width: 200px;
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    border-radius: 2px;
    input {
      min-width: 70px;
    }
    table {
      width: 100%;
    }
  }

  .close {
    position: absolute;
    right: 0;
    top: 0;
    padding: 15px;
    cursor: pointer;
    path {
      fill: #a6b5d1;
    }
    &:hover {
      path {
        fill: $blue;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tests/AnswerPoints.vue